import { LOADING, STATUS_CODE } from "../../constants/constant";
import {
  GET_BOT_DETAILS,
  GET_BOT_DETAILS_SUCCESS,
  GET_BOT_DETAILS_FAILED,
  RESET_STATE,
  GET_BOT_DETAILS_RESET,
} from "../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getBotDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BOT_DETAILS:
      let reqstState = Object.assign({}, state)
      reqstState.isLoading = true
      reqstState.status = LOADING
      reqstState.statusCode = STATUS_CODE
      return reqstState

    case GET_BOT_DETAILS_SUCCESS:
      let userRes = Object.assign({}, state)
      console.log(
        "getBotDetailsReducer => Case => Success: getting bot details: " +
          JSON.stringify(action.data)
      )
      //userRes.status = action.data.status;
      userRes.isLoading = false
      userRes.status = action.data.status_message
      userRes.statusCode = action.data.status_code

      userRes.bot_details = action.data.data.bot_details
      return userRes

    case GET_BOT_DETAILS_FAILED:
      console.error(
        "getBotDetailsReducer => Case => Error: while getting bot details: " +
          JSON.stringify(action.error)
      )
      return Object.assign({}, state, action.error)

    case RESET_STATE:
      return initialState
    case GET_BOT_DETAILS_RESET:
      return initialState

    default:
      return state
  }
}
